import {
  UPDATE_SETTING,
  GET_SETTING
} from './constants'

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/settings_controller.rb#L13
 * @return {Axios.IPromise<U>}
 */
export function putUpdateSetting (data) {
  return axios.put(UPDATE_SETTING, data, {withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    }).catch((error) => {
      let p
      if (error.response) {
        // handle different json from api... wkwkwk
        if (error.response.data.error) {
          p = Promise.reject(new Error(error.response.data.error))
        } else if (error.response.data.message) {
          p = Promise.reject(new Error(error.response.data.message))
        } else {
          p = Promise.reject(error)
        }
      } else {
        p = Promise.reject(error)
      }
      return p
    })
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/settings_controller.rb#L8
 * @param {object} params
 * @return {Axios.IPromise<U>}
 */
export function getSettings (params) {
  return axios.get(GET_SETTING, {params, withCredentials: true})
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      let eobj = new Error(err.message)
      return Promise.reject(eobj)
    })
}



// WEBPACK FOOTER //
// ./app/api/settings/index.js